// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"93723256","732":"f1609c38","977":"eb188ef1"}[chunkId] + ".chunk.js";
};